export default __webpack_public_path__ + "img/PIC_HE_Welcome_fw_de_de_93008.jpg";